import React from "react";

const ProgressBar = ({ percentage, color }) => {
  const getProgressBarColor = () => {
    switch (color) {
      case "danger":
        return "progress-bar--danger";
      case "success":
        return "progress-bar--success";
      case "warning":
        return "progress-bar--warning";
      default:
        return "progress-bar--primary";
    }
  };

  return (
    <div className="progress-bar">
      <div
        className={`progress-bar__fill ${getProgressBarColor()}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
